import { render, staticRenderFns } from "./admin-catalogo.vue?vue&type=template&id=0724850c&"
import script from "./admin-catalogo.vue?vue&type=script&lang=js&"
export * from "./admin-catalogo.vue?vue&type=script&lang=js&"
import style0 from "./admin-catalogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\eoninnovaction\\Development\\administracion\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0724850c')) {
      api.createRecord('0724850c', component.options)
    } else {
      api.reload('0724850c', component.options)
    }
    module.hot.accept("./admin-catalogo.vue?vue&type=template&id=0724850c&", function () {
      api.rerender('0724850c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/components/admin-catalogo/admin-catalogo.vue"
export default component.exports